import {Select} from "antd";
import "./big-picker.css";

type PickerOptionTypes = string | number | boolean;
type PickerOptionsListItem = {
    value: PickerOptionTypes;
    label: string | number;
    img?: string;
}

export interface BigPickerProps {
    value: PickerOptionTypes | null | undefined;
    setValue: (newVal: PickerOptionTypes) => void;
    placeholder?: string;
    options: PickerOptionsListItem[];
    selectClassName?: string;
    optionClassName?: string;
    disabled?: boolean;
}

const BigPicker = ({ value, setValue, placeholder, options, selectClassName, optionClassName, disabled = false }: BigPickerProps) => {
    return (
        <Select disabled={disabled} placeholder={placeholder} onChange={(newValue) => setValue(newValue)} className={`picker-select ${selectClassName}`} value={value}>
            {options.map((option, index) =>
                <Select.Option key={`td-option-${option.value}-${index}`} className={`picker-option ${optionClassName}`} value={option.value}>{option?.img ? <img src={option.img} className="option-image" /> : null}{option.label}</Select.Option>
            )}
        </Select>
    );
}

export default BigPicker;